import { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import 'components/sidebar/sidebar.scss';
import 'assets/styles/common.scss';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { LocaleContext } from 'routes/Router';
import {
  appointments,
  dashboard,
  doctor,
  enterprise,
  enterpriseDashboard,
  enterprisePatients,
  enterpriseProducts,
  location,
  leadCapture,
  patients,
  practices,
  products,
  questionnaire,
  request,
  revenueStream,
  setting,
  skinAnalyser,
  staff,
} from 'routes/AppUrls';
import { FormattedMessage, useIntl } from 'react-intl';
import Dashboard from 'assets/images/sidebar/dashboard.png';
import DashboardColor from 'assets/images/sidebar/dashboardColor.png';
import Request from 'assets/images/sidebar/requesrColor.png';
import RequestsColor from 'assets/images/sidebar/request.png';
import RequestIcon from 'assets/images/sidebar/requestIcon.png';
import RequestIconColor from 'assets/images/sidebar/requestIconColor.png';
import Doctor from 'assets/images/sidebar/doctor.svg';
import DoctorColor from 'assets/images/sidebar/doctorColor.svg';
import Practices from 'assets/images/sidebar/practices.svg';
import PracticesColor from 'assets/images/sidebar/practicesColor.svg';
import Patient from 'assets/images/sidebar/patient.png';
import PatientColor from 'assets/images/sidebar/patientColor.png';
import Question from 'assets/images/sidebar/question.svg';
import QuestionColor from 'assets/images/sidebar/questionColor.svg';
import product from 'assets/images/sidebar/product.svg';
import ProductColor from 'assets/images/sidebar/productColor.svg';
import settingIcon from 'assets/images/sidebar/setting.svg';
import settingColor from 'assets/images/sidebar/setting-select.svg';
import revenueColor from 'assets/images/sidebar/revenue.png';
import revenue from 'assets/images/sidebar/revenueColor.png';
import skinAnalysisColor from 'assets/images/sidebar/skinAnalysisColor.png';
import skinAnalysis from 'assets/images/sidebar/skinAnalysis.png';
import enterpriseColor from 'assets/images/sidebar/enterpriseColor.png';
import enterpriseIcon from 'assets/images/sidebar/enterprise.png';
import leadCaptureColor from 'assets/images/sidebar/leadCaptureColor.png';
import leadCaptureIcon from 'assets/images/sidebar/leadCapture.png';
import Logout from 'assets/images/sidebar/logout.png';
import { ClearTokenRedirectLogin, getUserRole } from 'utils/general';
import MenuIcon from '@mui/icons-material/Menu';
import sidebarLogo from 'assets/images/sidebar/sidebarLogo.png';
import { adminLogout } from 'store/AdminLogout/AdminLogoutAction';
import CommonModal from 'components/commom/Modal';
import ReusableButton from 'components/commom/Button';
import {
  ACTIVE_INDEX_ADMIN,
  basicDetailsValue,
} from 'store/BasicDetailaAllValue/BasicDetailsValueAction';
import CommonToast from 'components/commom/CommonToast';
import Staff from 'assets/images/sidebar/staff.png';
import StaffColor from 'assets/images/sidebar/staffColor.png';
import Location from 'assets/images/sidebar/location.png';
import LocationColor from 'assets/images/sidebar/locationColor.png';

const Sidebar = (props) => {
  const { window } = props;
  const intl = useIntl();
  const navigate = useNavigate();
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const userRole = getUserRole();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const { showToast } = CommonToast();
  const [isModal, setIsModal] = useState(false);

  const aIndex = useSelector((state) => state?.basicDetailsValueReducer);

  const [activeIndex, setActiveIndex] = useState(
    aIndex?.adminActiveIndex >= 0 ? aIndex?.adminActiveIndex : 0
  );
  const [openSubmenuIndex, setOpenSubmenuIndex] = useState(null);

  const logoutReducer = useSelector(
    (state) => state?.adminLogoutReducer?.loading
  );

  const sidebarData = [
    {
      name: intl.formatMessage({ id: 'Dashboard' }),
      icon: DashboardColor,
      selectedIcon: Dashboard,
      roles: ['DoctorAdmin', 'super-admin', 'enterprise-admin'],
    },
    {
      name: intl.formatMessage({ id: 'Requests' }),
      icon: RequestIconColor,
      selectedIcon: RequestIcon,
      roles: ['DoctorAdmin', 'super-admin'],
    },
    {
      name: intl.formatMessage({ id: 'Appointments' }),
      icon: RequestsColor,
      selectedIcon: Request,
      roles: ['DoctorAdmin', 'super-admin'],
    },
    {
      name: intl.formatMessage({ id: 'Doctors' }),
      icon: Doctor,
      selectedIcon: DoctorColor,
      roles: ['DoctorAdmin', 'super-admin'],
    },
    {
      name: intl.formatMessage({ id: 'Practices' }),
      icon: Practices,
      selectedIcon: PracticesColor,
      roles: ['DoctorAdmin', 'super-admin'],
    },
    {
      name: intl.formatMessage({ id: 'Patients' }),
      icon: PatientColor,
      selectedIcon: Patient,
      roles: ['DoctorAdmin', 'super-admin'],
    },
    {
      name: intl.formatMessage({ id: 'Skin Analyser' }),
      icon: skinAnalysisColor,
      selectedIcon: skinAnalysis,
      roles: ['DoctorAdmin', 'super-admin'],
    },
    {
      name: intl.formatMessage({ id: 'Questionnaire' }),
      icon: Question,
      selectedIcon: QuestionColor,
      roles: ['DoctorAdmin', 'super-admin'],
    },
    {
      name: intl.formatMessage({ id: 'Products' }),
      icon: product,
      selectedIcon: ProductColor,
      roles: ['DoctorAdmin', 'super-admin', 'enterprise-admin'],
    },
    {
      name: intl.formatMessage({ id: 'Revenue Stream' }),
      icon: revenue,
      selectedIcon: revenueColor,
      roles: ['DoctorAdmin', 'super-admin'],
    },
    {
      name: intl.formatMessage({ id: 'Enterprise' }),
      icon: enterpriseColor,
      selectedIcon: enterpriseIcon,
      roles: ['super-admin'],
    },
    {
      name: intl.formatMessage({ id: 'Lead Capture' }),
      icon: leadCaptureColor,
      selectedIcon: leadCaptureIcon,
      roles: ['super-admin'],
    },
    {
      name: intl.formatMessage({ id: 'Settings' }),
      icon: settingIcon,
      selectedIcon: settingColor,
      roles: ['DoctorAdmin', 'super-admin'],
    },
    {
      name: intl.formatMessage({ id: 'Staff' }),
      icon: Staff,
      selectedIcon: StaffColor,
      roles: ['DoctorAdmin', 'enterprise-admin'],
    },
    {
      name: intl.formatMessage({ id: 'Location' }),
      icon: Location,
      selectedIcon: LocationColor,
      roles: ['DoctorAdmin', 'enterprise-admin'],
    },
    {
      name: intl.formatMessage({ id: 'Logout' }),
      icon: Logout,
      selectedIcon: Logout,
      roles: ['DoctorAdmin', 'super-admin', 'enterprise-admin'],
    },
  ];

  const handleSubmenuToggle = (text, index) => {
    setOpenSubmenuIndex(openSubmenuIndex === index ? null : index);
    setActiveIndex(null);
    dispatch(basicDetailsValue(ACTIVE_INDEX_ADMIN, index));
  };

  const handleSubmenuRedirect = (text, index) => {
    setActiveIndex(index);
    switch (text?.name) {
      case intl.formatMessage({ id: '' }):
        break;
      case intl.formatMessage({ id: '' }):
        break;
      case intl.formatMessage({ id: '' }):
        break;
    }
  };

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const handleLogOutModal = () => {
    setIsModal(true);
  };

  const handleLogOut = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        ClearTokenRedirectLogin(navigate);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    let body = {};
    dispatch(adminLogout(body, external));
  };

  const handleMenuItemClick = (text, index) => {
    setOpenSubmenuIndex(null);

    if (text?.name === intl.formatMessage({ id: 'Logout' })) {
      handleLogOutModal();
      return;
    }
    switch (text?.name) {
      case intl.formatMessage({ id: 'Dashboard' }):
        userRole === 'enterprise-admin'
          ? navigate(enterpriseDashboard(locale))
          : navigate(dashboard(locale));
        break;
      case intl.formatMessage({ id: 'Requests' }):
        navigate(request(locale));
        break;
      case intl.formatMessage({ id: 'Doctors' }):
        navigate(doctor(locale));
        break;
      case intl.formatMessage({ id: 'Practices' }):
        navigate(practices(locale));
        break;
      case intl.formatMessage({ id: 'Patients' }):
        userRole === 'enterprise-admin'
          ? navigate(enterprisePatients(locale))
          : navigate(patients(locale));
        break;
      case intl.formatMessage({ id: 'Questionnaire' }):
        navigate(questionnaire(locale));
        break;
      case intl.formatMessage({ id: 'Products' }):
        userRole === 'enterprise-admin'
          ? navigate(enterpriseProducts(locale))
          : navigate(products(locale));
        break;
      case intl.formatMessage({ id: 'Settings' }):
        navigate(setting(locale));
        break;
      case intl.formatMessage({ id: 'Appointments' }):
        navigate(appointments(locale));
        break;
      case intl.formatMessage({ id: 'Revenue Stream' }):
        navigate(revenueStream(locale));
        break;
      case intl.formatMessage({ id: 'Skin Analyser' }):
        navigate(skinAnalyser(locale));
        break;
      case intl.formatMessage({ id: 'Enterprise' }):
        navigate(enterprise(locale));
        break;
      case intl.formatMessage({ id: 'Staff' }):
        navigate(staff(locale));
        break;
      case intl.formatMessage({ id: 'Location' }):
        navigate(location(locale));
        break;
      case intl.formatMessage({ id: 'Lead Capture' }):
        navigate(leadCapture(locale));
        break;
    }
    setActiveIndex(index);

    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
    dispatch(basicDetailsValue(ACTIVE_INDEX_ADMIN, index));
  };

  const filteredSidebarData = sidebarData.filter((item) =>
    item.roles.includes(userRole)
  );

  const drawer = (
    <div>
      <Toolbar className={`flex-col justify-center pl-5 pt-5 pr-5 mt-1`}>
        <img src={sidebarLogo} alt={'logo'} />
      </Toolbar>

      <List className="sidebarList ">
        {filteredSidebarData.map((text, index) => (
          <div key={index}>
            <ListItem
              disablePadding
              className={
                text?.name === intl.formatMessage({ id: 'Logout' })
                  ? 'sidebarBottom'
                  : index + 1 === filteredSidebarData?.length - 1
                    ? `mt-3 mb-5 ${activeIndex === index ? 'borderLeftShow' : 'borderLeftWithoutShow'}`
                    : `mt-3 ${activeIndex === index ? 'borderLeftShow' : 'borderLeftWithoutShow'}`
              }
            >
              <ListItemButton
                onClick={() => {
                  if (text.children) {
                    handleSubmenuToggle(text, index);
                  } else {
                    handleMenuItemClick(text, index);
                  }
                }}
                className={
                  activeIndex === index ||
                  (text.children && openSubmenuIndex === index)
                    ? 'active-menu-item '
                    : ''
                }
              >
                <ListItemIcon>
                  <Image
                    src={
                      activeIndex === index ||
                      (text.children && openSubmenuIndex === index)
                        ? text?.selectedIcon
                        : text?.icon
                    }
                    alt={'icon'}
                    style={{ height: '24px', width: '24px' }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={text?.name}
                  className={
                    text?.name === intl.formatMessage({ id: 'Logout' })
                      ? 'Item-logout'
                      : 'Item-text'
                  }
                />
              </ListItemButton>
            </ListItem>

            {text.children && openSubmenuIndex === index && (
              <List className="submenuList pb-0">
                {text.children.map((subItem, subIndex) => (
                  <ListItem
                    key={`${index}-${subIndex}`}
                    className="ml-0"
                    disablePadding
                  >
                    <ListItemButton
                      onClick={() => {
                        handleSubmenuRedirect(subItem, `${index}-${subIndex}`);
                      }}
                      className={
                        activeIndex === `${index}-${subIndex}`
                          ? 'active-submenu-item'
                          : ''
                      }
                    >
                      <ListItemText
                        className="Item-text"
                        primary={subItem.name}
                      />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            )}
          </div>
        ))}
      </List>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <>
      <Row>
        <Col md={0} lg={2} className="sidebar">
          <Box sx={{ display: 'flex' }}>
            <AppBar>
              <Toolbar className="d-xl-none menu-container">
                <Stack direction="horizontal" gap={4} className="d-flex">
                  <MenuIcon
                    style={{
                      fontSize: '2rem',
                      color: '#292D32',
                      cursor: 'pointer',
                    }}
                    onClick={handleDrawerToggle}
                  />
                  <p className="mb-0 menu-text">
                    <FormattedMessage id="Absolut Skin" />
                  </p>
                </Stack>
              </Toolbar>
            </AppBar>

            <Box component="nav" aria-label="mailbox folders">
              <Drawer
                container={container}
                variant="temporary"
                open={mobileOpen}
                anchor={locale === 'en' ? 'left' : 'right'}
                onTransitionEnd={handleDrawerTransitionEnd}
                onClose={handleDrawerClose}
                ModalProps={{
                  keepMounted: true,
                }}
                sx={{
                  display: { md: 'block', lg: 'none' },
                  '& .MuiDrawer-paper': {
                    boxSizing: 'border-box',
                    width: '240px',
                  },
                }}
              >
                {drawer}
              </Drawer>

              <Drawer
                variant="permanent"
                anchor={locale === 'en' ? 'left' : 'right'}
                className="drawer-menu d-none d-xl-block"
                sx={{
                  '& .MuiDrawer-paper': {
                    boxSizing: 'border-box',
                    borderRight: 'none',
                  },
                }}
                open
              >
                {drawer}
              </Drawer>
            </Box>
          </Box>
        </Col>
      </Row>

      <CommonModal
        padding={'24px'}
        width={'500px'}
        modalActive={isModal}
        innerContent={
          <div>
            <Row>
              <Col xs={12}>
                <div className="">
                  <p className="p-0 m-0 fs-24 fc-292D32 family_outfit_semiBold_600">
                    Are you sure you want to log out?
                  </p>
                </div>
              </Col>
              <Col xs={12} md={12} className="mt-3 flex justify-end">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center justify-end p-0"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#EFE3D7"
                    fontFamily="outfit_medium"
                    onClick={() => setIsModal(false)}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      !logoutReducer && handleLogOut();
                    }}
                    loading={logoutReducer}
                  >
                    <FormattedMessage id="Logout" />
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />
    </>
  );
};

Sidebar.propTypes = {
  window: PropTypes.func,
};

export default Sidebar;
